import $ from 'jquery'
import navigationViewport from './navigation--viewport.js'
import 'jquery-menuAim'
	navigationViewport.then(function() {
		var $menu = $(".navigation--main .navigation--sub");

		function initMenuAim() {
			if(window.fitNavigationViewport === 'desktop') {
				$menu.menuAim({
					activate: activateSubmenu,
					deactivate: deactivateSubmenu,
					exitMenu: function () {
						return true;
					}
				});
				$menu.find('> .navigation__item').addClass('navigation__item--disable-hover');
        $menu.each(function() { this.addEventListener('navigation-item-selected', activateRowListener); });
			} else {
				$menu.menuAim('destroy');
				$menu.find('> .navigation__item').removeClass('navigation__item--disable-hover');
        $menu.each(function() { this.removeEventListener('navigation-item-selected', activateRowListener); });
			}
		}

		function activateRowListener(event) {
      var menuAim = $(event.target).closest(".navigation--main .navigation--sub").data("jquery.menu-aim");
      menuAim && menuAim.activate(event.target);
		}

		function activateSubmenu(row) {
			row.classList.add('navigation__item--hover');
		}

		function deactivateSubmenu(row) {
			row.classList.remove('navigation__item--hover');
		}

		document.body.addEventListener('navigationChange', initMenuAim);
		initMenuAim();
	});
